import { FunnelSettingsServiceInterface } from './interfaces';

export class FunnelSettingsService implements FunnelSettingsServiceInterface {
  private funnelName = 'unknown';
  private funnelLocale = 'en';

  getFunnelName() {
    return this.funnelName;
  }

  setFunnelName(funnelName: string) {
    this.funnelName = funnelName;
  }

  getFunnelLocale() {
    return this.funnelLocale;
  }

  setFunnelLocale(funnelLocale: string) {
    this.funnelLocale = funnelLocale;
  }
}
